module.exports = __webpack_public_path__ + "asset/rightCircle_bfib2l74.png";